/**
 * Menvora — COD Dev Interceptor
 *
 * Bloquea creación real de pedidos COD en entornos de prueba y expone el
 * payload capturado (FormData + campos clave) para QA.
 *
 * Activo cuando:
 *   - hostname es 127.0.0.1 / localhost / 0.0.0.0  (siempre)
 *   - ?menvora_cod_intercept=1|error|ok
 *   - window.MENVORA_COD_INTERCEPT = true | 'ok' | 'error'
 *   - Shopify.designMode === true
 *
 * En menvora.mx sin flag → no-op total (early return).
 *
 * Modes:
 *   error (default) → bloquea + overlay rojo "pedido NO enviado"
 *   ok              → bloquea + overlay verde simulando éxito falso
 */
(function () {
  if (window.__menvoraCodDevIntercept) return;
  window.__menvoraCodDevIntercept = true;

  function readMode() {
    try {
      var q = new URLSearchParams(location.search || '');
      var fromQ = (q.get('menvora_cod_intercept') || '').toLowerCase();
      if (fromQ === 'ok' || fromQ === 'success') return 'ok';
      if (fromQ === '1' || fromQ === 'true' || fromQ === 'error' || fromQ === 'block') return 'error';
    } catch (e) { /* noop */ }

    var w = window.MENVORA_COD_INTERCEPT;
    if (w === true || w === 1 || w === 'error' || w === 'block') return 'error';
    if (w === 'ok' || w === 'success') return 'ok';

    if (window.Shopify && window.Shopify.designMode) return 'error';

    var h = String(location.hostname || '');
    if (h === '127.0.0.1' || h === 'localhost' || h === '0.0.0.0' || h === '[::1]') {
      return 'error';
    }
    return null;
  }

  var MODE = readMode();
  if (!MODE) return; // prod / host real sin flag → inerte

  var BANNER_ID = 'menvora-cod-dev-intercept-banner';
  var OVERLAY_ID = 'menvora-cod-dev-intercept-overlay';

  function log() {
    var a = ['[cod-dev-intercept]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, a);
  }

  function injectCss() {
    if (document.getElementById('menvora-cod-dev-intercept-css')) return;
    var s = document.createElement('style');
    s.id = 'menvora-cod-dev-intercept-css';
    s.textContent = [
      '#' + BANNER_ID + '{',
      'position:fixed;top:0;left:0;right:0;z-index:2147483000;',
      'background:#1a1a1a;color:#fff;font:12px/1.35 system-ui,sans-serif;',
      'padding:8px 12px;text-align:center;box-shadow:0 2px 8px rgba(0,0,0,.25)',
      '}',
      '#' + BANNER_ID + ' strong{color:#fbbf24}',
      '#' + OVERLAY_ID + '{',
      'position:fixed;inset:0;z-index:2147483001;background:rgba(0,0,0,.55);',
      'display:flex;align-items:center;justify-content:center;padding:16px',
      '}',
      '#' + OVERLAY_ID + ' .menvora-cod-dev-card{',
      'background:#fff;color:#111;max-width:440px;width:100%;border-radius:12px;',
      'padding:18px 16px;font:13px/1.45 system-ui,sans-serif;box-shadow:0 12px 40px rgba(0,0,0,.35)',
      '}',
      '#' + OVERLAY_ID + ' .menvora-cod-dev-card h2{margin:0 0 8px;font-size:16px}',
      '#' + OVERLAY_ID + ' .menvora-cod-dev-card.ok h2{color:#166534}',
      '#' + OVERLAY_ID + ' .menvora-cod-dev-card.error h2{color:#991b1b}',
      '#' + OVERLAY_ID + ' pre{',
      'margin:10px 0 0;max-height:220px;overflow:auto;background:#f4f4f5;',
      'padding:10px;border-radius:8px;font-size:11px;line-height:1.35',
      '}',
      '#' + OVERLAY_ID + ' .menvora-cod-dev-actions{display:flex;gap:8px;margin-top:12px;flex-wrap:wrap}',
      '#' + OVERLAY_ID + ' button{',
      'border:0;border-radius:8px;padding:8px 12px;font-weight:700;cursor:pointer',
      '}',
      '#' + OVERLAY_ID + ' .btn-close{background:#111;color:#fff}',
      '#' + OVERLAY_ID + ' .btn-copy{background:#e5e7eb;color:#111}',
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }

  function showBanner() {
    injectCss();
    if (document.getElementById(BANNER_ID)) return;
    var b = document.createElement('div');
    b.id = BANNER_ID;
    b.innerHTML =
      'COD <strong>DEV INTERCEPT</strong> activo (' +
      MODE +
      ') — los pedidos <strong>no</strong> se crean. ' +
      location.hostname;
    document.documentElement.appendChild(b);
  }

  function snapshotForm(form) {
    var data = {
      ts: new Date().toISOString(),
      mode: MODE,
      host: location.hostname,
      href: location.href,
      fields: {},
      formData: {},
      shippingRate: null,
      checks: {},
    };

    if (form) {
      try {
        var fd = new FormData(form);
        fd.forEach(function (v, k) {
          data.formData[k] = String(v);
        });
      } catch (e) { /* noop */ }
    }

    var wrap = document.getElementById('rsi_form_wrapper') || document;
    var ids = [
      'first_name',
      'phone',
      'zip_code',
      'province_country_field',
      'city',
      'address',
      'civic_number',
      'menvora-colonia-select',
    ];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (el.tagName === 'SELECT' && el.selectedIndex >= 0) {
        var opt = el.options[el.selectedIndex];
        data.fields[id] = (opt && (opt.text || opt.value)) || el.value;
      } else {
        data.fields[id] = el.value;
      }
    });

    var radio =
      (form && form.querySelector('input[name="shippingRate"]:checked')) ||
      wrap.querySelector('input[name="shippingRate"]:checked') ||
      wrap.querySelector('input.rsi-shipping-rates-radio:checked');
    if (radio) {
      data.shippingRate = { name: radio.name, value: radio.value, checked: !!radio.checked };
    }

    var rsiWrap = document.getElementById('rsi_form_wrapper');
    data.checks = {
      cpApplied: rsiWrap && rsiWrap.getAttribute('data-menvora-cp-applied'),
      noCoverage: rsiWrap && rsiWrap.getAttribute('data-menvora-cp-no-coverage'),
      shippingInFormData: !!(data.formData && data.formData.shippingRate),
      zipInFormData: !!(data.formData && data.formData.zip_code),
    };

    return data;
  }

  function showOverlay(payload) {
    injectCss();
    var old = document.getElementById(OVERLAY_ID);
    if (old) old.remove();

    var ov = document.createElement('div');
    ov.id = OVERLAY_ID;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');

    var card = document.createElement('div');
    card.className = 'menvora-cod-dev-card ' + (MODE === 'ok' ? 'ok' : 'error');

    var title =
      MODE === 'ok'
        ? 'Simulación OK — pedido NO creado'
        : 'Interceptado — pedido NO enviado';

    card.innerHTML =
      '<h2>' +
      title +
      '</h2>' +
      '<p>Host <code>' +
      location.hostname +
      '</code>. Revisa FormData abajo. Esto es solo QA en local/dev.</p>' +
      '<pre></pre>' +
      '<div class="menvora-cod-dev-actions">' +
      '<button type="button" class="btn-copy">Copiar JSON</button>' +
      '<button type="button" class="btn-close">Cerrar</button>' +
      '</div>';

    var pre = card.querySelector('pre');
    pre.textContent = JSON.stringify(payload, null, 2);

    card.querySelector('.btn-close').addEventListener('click', function () {
      ov.remove();
    });
    card.querySelector('.btn-copy').addEventListener('click', function () {
      var txt = JSON.stringify(payload, null, 2);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).catch(function () {});
      }
    });
    ov.addEventListener('click', function (e) {
      if (e.target === ov) ov.remove();
    });

    ov.appendChild(card);
    document.documentElement.appendChild(ov);
  }

  function intercept(reason, form) {
    try {
      var wrap = document.getElementById('rsi_form_wrapper');
      var applied = wrap && wrap.getAttribute('data-menvora-cp-applied');
      if (applied && typeof window.__menvoraPrefillEnforceLocation === 'function') {
        window.__menvoraPrefillEnforceLocation(applied);
      }
    } catch (eEnf) { /* noop */ }
    try {
      if (typeof window.MenvoraCodNormalizeProvinceForShopify === 'function') {
        window.MenvoraCodNormalizeProvinceForShopify();
      }
    } catch (eNorm) { /* noop */ }
    var payload = snapshotForm(form || document.querySelector('#rsi_form_wrapper form'));
    payload.reason = reason;
    window.__menvoraCodLastIntercept = payload;
    log(reason, payload);
    showOverlay(payload);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'CodDevIntercept',
        mode: MODE,
        reason: reason,
        shippingRate: payload.shippingRate && payload.shippingRate.value,
        cpApplied: payload.checks && payload.checks.cpApplied,
      });
    } catch (e) { /* noop */ }

    return false;
  }

  function isSubmitControl(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      'button.rsi-additionals_checkout_button, button.rsi-submit_button, ' +
        'button[type="submit"], [data-rsi-cod-button="true"]'
    );
  }

  // Capture-phase: click submit
  document.addEventListener(
    'click',
    function (e) {
      var btn = isSubmitControl(e.target);
      if (!btn) return;
      // No bloquear el CTA de abrir form
      if (btn.id === 'rsi_buy_now_button') return;
      var form =
        (btn.form) ||
        btn.closest('form') ||
        document.querySelector('#rsi_form_wrapper form');
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      intercept('click:' + (btn.className || btn.id || 'submit'), form);
    },
    true
  );

  // Capture-phase: form submit
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      if (!form.closest('#rsi_form_wrapper') && !form.classList.contains('_rsi_main_form_element')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      intercept('submit', form);
    },
    true
  );

  // Network: bloquear fetch/XHR sospechosos de crear pedido / WA handoff
  var BLOCK_RE =
    /wa\.me|api\.whatsapp\.com|cash.?on.?delivery|cod.?order|create.?order|\/cart\/add|checkout|releasit|thank[_-]?you/i;

  function shouldBlockUrl(url) {
    try {
      var s = String(url || '');
      // Shop Pay eligibility / accelerated checkout ≠ creación de pedido COD
      if (/shopify_pay|accelerated_checkout/i.test(s)) return false;
      return BLOCK_RE.test(s);
    } catch (e) {
      return false;
    }
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (shouldBlockUrl(url)) {
        log('blocked fetch', url);
        intercept('fetch:' + url, null);
        return Promise.reject(new Error('[menvora-cod-dev-intercept] blocked fetch: ' + url));
      }
      return _fetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__menvoraInterceptUrl = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (shouldBlockUrl(this.__menvoraInterceptUrl)) {
        log('blocked xhr', this.__menvoraInterceptUrl);
        intercept('xhr:' + this.__menvoraInterceptUrl, null);
        try {
          this.abort();
        } catch (e) { /* noop */ }
        return;
      }
      return _send.apply(this, arguments);
    };
  }

  // Expose helpers for manual QA / Playwright
  window.MenvoraCodDevIntercept = {
    mode: MODE,
    enabled: true,
    last: function () {
      return window.__menvoraCodLastIntercept || null;
    },
    snapshot: function () {
      return snapshotForm(document.querySelector('#rsi_form_wrapper form'));
    },
  };

  showBanner();
  log('enabled mode=', MODE, 'host=', location.hostname);
})();
